export default __webpack_public_path__ + "static/media/patent02-1.93b82a8e.png";